import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBvi6xU0PO2eWRnH8jp-X0S1az7FV0lAFQ",
    authDomain: "wendy-blearm-store.firebaseapp.com",
    projectId: "wendy-blearm-store",
    storageBucket: "wendy-blearm-store.appspot.com",
    messagingSenderId: "326565192879",
    appId: "1:326565192879:web:6f299537eb92821c5f205a",
    measurementId: "G-BX2DVP7385"
  };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const firestore = firebase.firestore();
const storage = getStorage()

export {firebase, auth, firestore, storage}